export default "__VITE_ASSET__BMsFP82u__"